import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '/api';

interface BannerItem {
  id: number;
  titulo: string;
  url: string;
  url_destino: string;
  posicion: string;
}

interface Props {
  posicion: 'superior' | 'inferior';
}

export default function BannerCarrusel({ posicion }: Props) {
  const [banners, setBanners]   = useState<BannerItem[]>([]);
  const [actual, setActual]     = useState(0);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    axios.get(`${API}/banners/?posicion=${posicion}`)
      .then(r => { setBanners(r.data); setCargando(false); })
      .catch(() => setCargando(false));
  }, [posicion]);

  const siguiente = useCallback(() => {
    setActual(a => (a + 1) % banners.length);
  }, [banners.length]);

  useEffect(() => {
    if (banners.length <= 1) return;
    const interval = setInterval(siguiente, 5000);
    return () => clearInterval(interval);
  }, [banners.length, siguiente]);

  if (cargando || banners.length === 0) return null;

  return (
    <div className="relative w-full overflow-hidden bg-black">
      {banners.map((b, i) => (
        <div key={b.id} className="absolute inset-0 transition-opacity duration-700"
          style={{ opacity: i === actual ? 1 : 0 }}>
          {b.url_destino ? (
            <a href={b.url_destino} target="_blank" rel="noreferrer" className="block w-full">
              <img src={b.url} alt={b.titulo || "Banner"} className="w-full h-auto block" />
            </a>
          ) : (
            <img src={b.url} alt={b.titulo || "Banner"} className="w-full h-auto block" />
          )}
        </div>
      ))}
      <img src={banners[actual].url} alt="" className="w-full h-auto block opacity-0 pointer-events-none" aria-hidden="true" />
      {banners.length > 1 && (
        <>
          <button onClick={() => setActual(a => (a - 1 + banners.length) % banners.length)}
            className="absolute left-3 top-1/2 -translate-y-1/2 z-10 bg-black/40 hover:bg-black/60 text-white w-9 h-9 rounded-full flex items-center justify-center text-xl"
            aria-label="Anterior">&#8249;</button>
          <button onClick={siguiente}
            className="absolute right-3 top-1/2 -translate-y-1/2 z-10 bg-black/40 hover:bg-black/60 text-white w-9 h-9 rounded-full flex items-center justify-center text-xl"
            aria-label="Siguiente">&#8250;</button>
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2 z-10">
            {banners.map((_, i) => (
              <button key={i} onClick={() => setActual(i)}
                className={"h-2 rounded-full transition-all " + (i === actual ? "bg-white w-5" : "bg-white/50 w-2")}
                aria-label={"Banner " + (i+1)} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
